/**
 * One document waiting in `messages/from_app` for the store service.
 */
export interface IFromAppQueueItem {
  id: string;
  type: string;
  storeId?: string;
  storeName?: string;
}
